import { createApp } from 'vue'
import axios from 'axios'
import Qs from 'qs'
import { initSearchPanel } from '../legacy/search-panel.js'

document.addEventListener('DOMContentLoaded', () => {
    var form = document.forms.search_panel
    if (!form) return

    // ホームから遷移してきた場合に検索結果エリアへスクロール
    if (window.location.pathname === '/orders' && document.referrer.includes(window.location.origin + '/')) {
        var referrerPath = new URL(document.referrer).pathname
        if (referrerPath === '/') {
            var el = document.getElementById('results')
            if (el) el.scrollIntoView({ behavior: 'instant' })
        }
    }

    var selectedPrefecture = form['form_search_order[hospital_prefecture_id_in]'].value
    var selectedJob = form['form_search_order[wanted_jobs_cont]'].value

    const app = createApp({
        data: function () {
            return {
                filtered_count: '-',
                query: {
                    fulltime_salary: (form['form_search_order[fulltime_salary]'] || {}).value || '',
                    hospital_prefecture_id_in: selectedPrefecture,
                    wanted_jobs_cont: selectedJob,
                    facility_category: (form['form_search_order[facility_category]'] || {}).value || '',
                    keywords: form['form_search_order[keywords]'].value
                },
                selected_area: selectedPrefecture === '' ? 'エリアを選択' : selectedPrefecture,
                selected_type: selectedJob === '' ? '職種を選択' : selectedJob,
                prefecture_ids: selectedPrefecture.length > 0 ? selectedPrefecture.split(' ') : [],
                job_ids: selectedJob.length > 0 ? selectedJob.split(' ') : []
            }
        },
        created: function () {
            this.search()
        },
        mounted: function () {
            this.initialize_all_and_region()
            this.initialize_all_and_type()
        },
        watch: {
            prefecture_ids: {
                handler: function () {
                    this.set_selected_prefecture(this.prefecture_ids.join(' '))
                },
                deep: true
            },
            job_ids: {
                handler: function () {
                    this.set_selected_job(this.job_ids.join(' '))
                },
                deep: true
            },
            query: {
                handler: function () { this.search() },
                deep: true
            }
        },
        methods: {
            // 検索
            search: function () {
                axios.get('/orders.json', {
                    params: { form_search_order: this.query },
                    paramsSerializer: function (params) {
                        return Qs.stringify(params, {arrayFormat: 'brackets'})
                    }
                })
                .then((response) => {
                    this.filtered_count = response.data.pagination.total_count
                })
                .catch((error) => {
                    console.error(error)
                })
            },
            set_selected_prefecture: function (selected_prefecture) {
                this.query.hospital_prefecture_id_in = selected_prefecture
                this.selected_area = selected_prefecture === '' ? 'エリアを選択' : selected_prefecture
            },
            trim_prefecture: function (selected_prefecture) {
                return selected_prefecture.length > 7 ? selected_prefecture.substr(0, 7) + '…' : selected_prefecture
            },
            set_selected_job: function (selected_job) {
                this.query.wanted_jobs_cont = selected_job
                this.selected_type = selected_job === '' ? '職種を選択' : selected_job
            },
            trim_job: function (selected_job) {
                return selected_job.length > 7 ? selected_job.substr(0, 7) + '…' : selected_job
            },

            // エリアモーダル
            initialize_all_and_region: function () {
                var groups = document.getElementsByClassName('selectArea__group')
                for (var i = 1; i < groups.length; i++) {
                    var prefectures = this.get_prefectures(groups[i])
                    for (var j = 0; j < prefectures.length; j++) {
                        if (!this.is_checked_prefecture(prefectures[j])) {
                            break
                        } else if (j === (prefectures.length - 1)) {
                            this.check_region(groups[i])
                        }
                    }
                }
                for (var i = 1; i < groups.length; i++) {
                    if (!this.is_checked_region(groups[i])) {
                        break
                    } else if (i === (groups.length - 1)) {
                        this.check_all(groups)
                    }
                }
            },
            check_or_cancel_all: function (event) {
                var groups = document.getElementsByClassName('selectArea__group')
                for (var i = 1; i < groups.length; i++) {
                    this.make_same_checked_status_with_event(groups[i], event)
                    var prefectures = this.get_prefectures(groups[i])
                    this.check_or_cancel_prefectures(event, prefectures)
                }
            },
            check_or_cancel_region: function (event) {
                var prefectures = this.get_prefectures(event.target.parentElement.parentElement.parentElement)
                this.check_or_cancel_prefectures(event, prefectures)
                var groups = document.getElementsByClassName('selectArea__group')
                this.check_or_cancel_all_with_groups(groups, event)
            },
            check_or_cancel_prefecture: function (event) {
                var prefectures = event.target.parentElement.parentElement.parentElement.children
                var target_region_group = event.target.parentElement.parentElement.parentElement.parentElement.parentElement
                if (event.target.checked) {
                    for (var i = 0; i < prefectures.length; i++) {
                        if (!this.is_checked_prefecture(prefectures[i]) && !this.is_target_prefecture_id(prefectures[i], event)) {
                            break
                        } else if (i === (prefectures.length - 1)) {
                            this.make_same_checked_status_with_event(target_region_group, event)
                        }
                    }
                } else {
                    this.make_same_checked_status_with_event(target_region_group, event)
                }
                var groups = document.getElementsByClassName('selectArea__group')
                this.check_or_cancel_all_with_groups(groups, event)
            },
            get_prefectures: function (group) {
                return group.children[1].children[0].children
            },
            is_checked_prefecture: function (prefecture) {
                return this.get_index_of_prefecture_ids(prefecture) >= 0
            },
            get_index_of_prefecture_ids: function (prefecture) {
                return this.prefecture_ids.indexOf(this.get_prefecture_id(prefecture))
            },
            get_prefecture_id: function (prefecture) {
                return prefecture.children[0].children[0].value
            },
            is_target_prefecture_id: function (prefecture, event) {
                return this.get_prefecture_id(prefecture) === event.target.value
            },
            check_region: function (group) {
                this.get_all_or_region_checkbox(group).checked = true
            },
            get_all_or_region_checkbox: function (group) {
                return group.children[0].children[0].children[0]
            },
            is_checked_region: function (group) {
                return this.get_all_or_region_checkbox(group).checked
            },
            check_all: function (groups) {
                this.get_all_or_region_checkbox(groups[0]).checked = true
            },
            make_same_checked_status_with_event: function (target_group, event) {
                this.get_all_or_region_checkbox(target_group).checked = event.target.checked
            },
            check_or_cancel_prefectures: function (event, prefectures) {
                if (event.target.checked) {
                    for (var i = 0; i < prefectures.length; i++) {
                        if (!this.is_checked_prefecture(prefectures[i])) {
                            this.check_prefecture(prefectures[i])
                        }
                    }
                } else {
                    for (var i = 0; i < prefectures.length; i++) {
                        if (this.is_checked_prefecture(prefectures[i])) {
                            this.cancel_prefecture(prefectures[i])
                        }
                    }
                }
            },
            check_prefecture: function (prefecture) {
                this.prefecture_ids.push(this.get_prefecture_id(prefecture))
            },
            cancel_prefecture: function (prefecture) {
                this.prefecture_ids.splice(this.get_index_of_prefecture_ids(prefecture), 1)
            },
            check_or_cancel_all_with_groups: function (groups, event) {
                if (this.is_checked_all(groups)) {
                    for (var i = 1; i < groups.length; i++) {
                        if (this.is_checked_region(groups[i]) !== this.is_checked_all(groups)) {
                            this.make_same_checked_status_with_group(groups[0], groups[i])
                            break
                        }
                    }
                } else {
                    for (var i = 1; i < groups.length; i++) {
                        if (this.is_checked_region(groups[i]) !== this.is_checked_all(groups)) {
                            if (i === (groups.length - 1)) {
                                this.make_same_checked_status_with_event(groups[0], event)
                            }
                        } else {
                            break
                        }
                    }
                }
            },
            is_checked_all: function (groups) {
                return this.get_all_or_region_checkbox(groups[0]).checked
            },
            make_same_checked_status_with_group: function (target_group, source_group) {
                this.get_all_or_region_checkbox(target_group).checked = this.get_all_or_region_checkbox(source_group).checked
            },

            // 職種モーダル
            initialize_all_and_type: function () {
                var job_groups = document.getElementsByClassName('selectJob__group')
                for (var i = 1; i < job_groups.length; i++) {
                    var jobs = this.get_jobs(job_groups[i])
                    for (var j = 0; j < jobs.length; j++) {
                        if (!this.is_checked_job(jobs[j])) {
                            break
                        } else if (j === (jobs.length - 1)) {
                            this.check_type(job_groups[i])
                        }
                    }
                }
                for (var i = 1; i < job_groups.length; i++) {
                    if (!this.is_checked_type(job_groups[i])) {
                        break
                    }
                }
            },
            check_or_cancel_type: function (event) {
                var jobs = this.get_jobs(event.target.parentElement.parentElement.parentElement)
                this.check_or_cancel_jobs(event, jobs)
            },
            check_or_cancel_job: function (event) {
                var jobs = event.target.parentElement.parentElement.parentElement.children
                var target_type_group = event.target.parentElement.parentElement.parentElement.parentElement.parentElement
                if (event.target.checked) {
                    for (var i = 0; i < jobs.length; i++) {
                        if (!this.is_checked_job(jobs[i]) && !this.is_target_job_id(jobs[i], event)) {
                            break
                        } else if (i === (jobs.length - 1)) {
                            this.make_same_checked_job_status_with_event(target_type_group, event)
                        }
                    }
                } else {
                    this.make_same_checked_job_status_with_event(target_type_group, event)
                }
            },
            get_jobs: function (group) {
                return group.children[1].children[0].children
            },
            is_checked_job: function (job) {
                return this.get_index_of_job_ids(job) >= 0
            },
            get_index_of_job_ids: function (job) {
                return this.job_ids.indexOf(this.get_job_id(job))
            },
            get_job_id: function (job) {
                return job.children[0].children[0].value
            },
            is_target_job_id: function (job, event) {
                return this.get_job_id(job) === event.target.value
            },
            check_type: function (group) {
                this.get_all_or_type_checkbox(group).checked = true
            },
            get_all_or_type_checkbox: function (group) {
                return group.children[0].children[0].children[0]
            },
            is_checked_type: function (group) {
                return this.get_all_or_type_checkbox(group).checked
            },
            make_same_checked_job_status_with_event: function (target_group, event) {
                this.get_all_or_type_checkbox(target_group).checked = event.target.checked
            },
            check_or_cancel_jobs: function (event, jobs) {
                if (event.target.checked) {
                    for (var i = 0; i < jobs.length; i++) {
                        if (!this.is_checked_job(jobs[i])) {
                            this.check_job(jobs[i])
                        }
                    }
                } else {
                    for (var i = 0; i < jobs.length; i++) {
                        if (this.is_checked_job(jobs[i])) {
                            this.cancel_job(jobs[i])
                        }
                    }
                }
            },
            check_job: function (job) {
                this.job_ids.push(this.get_job_id(job))
            },
            cancel_job: function (job) {
                this.job_ids.splice(this.get_index_of_job_ids(job), 1)
            }
        }
    })
    app.mount('#searchPanelApp')
    initSearchPanel()
})
